import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';
import { Row } from '@lightningjs/ui-components';
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';

//Components
import Button from './components/Button';

export const ExitOptions = [
  { id: 1, title: 'No, resume' },
  { id: 2, title: 'Yes, exit now' },
];

export default class Exit extends AuthRoute {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('#000000').get(),
      alpha: 0.9,
      LogoWrapper: {
        w: 1920,
        x: 740,
        y: 310,
        flex: { direction: 'row', justifyConten: 'center' },
        Logo: {
          texture: lng.Tools.getSvgTexture(Utils.asset('/images/logo.png'), 438, 68),
        },
      },
      Text: {
        y: 445,
        x: 602.5,
        text: {
          text: 'Are you sure you want to exit the app?',
          fontFace: 'OpenSans-Regular',
          color: Colors('#fafafa').get(),
        },
      },
      Row: {
        type: Row,
        y: 610,
        x: 715,
        collision: true,
        items: ExitOptions.map((option, index) => ({
          collision: true,
          type: Button,
          index,
          option,
          color: Colors('#292929').get(),
        })),
      },
    };
  }

  get _Row() {
    return this.tag('Row');
  }

  _getFocused() {
    return this._Row;
  }

  $setIndex(index) {
    this._Row.selectedIndex = index;
  }
}
